<div class="laneone row space-between align-center">
    <div class="row align-center">
        <div class="padding-12 col">
            <rr-icon class="w24" name="wind" color="nutral"></rr-icon>
        </div>
        <div class="col gap-4">
            <span class="strong">{{ stream?.name }}</span>
            <span
                >Created:
                {{ stream?.dateCreate! | timeToLocaleDateString }}</span
            >
        </div>
    </div>
    <div class="btnarea row align-center gap-16">
        <div class="col">
            <rr-icon
                name="more"
                class="pointer"
                (click)="showMenue = !showMenue"
            >
            </rr-icon>
            @if(showMenue === true){
            <div class="menue-bg" (click)="showMenue = false"></div>
            <div class="submenue col gap-4">
                <span class="item" (click)="deleteStreamClicked()">Delete</span>
            </div>
            }
        </div>

        @if(stream?.finished === true){
        <rr-btn type="Secondary" size="Small" (click)="gotoResults()"
            >Results</rr-btn
        >
        }@else{
        <rr-btn type="Primary" size="Small" (click)="continue()"
            >Continue</rr-btn
        >
        }
    </div>
</div>
<rr-divider></rr-divider>
<div class="lanetwo row gap-8">
    <rr-badge *ngFor="let c of categories">{{
        c | getCategoryNameById
    }}</rr-badge>
    <rr-badge>{{ streamName || "Stream deprecated" }}</rr-badge>
    <!--
    @if(stream?.industryId) {
    <rr-badge>{{ stream?.industryId! | getIndustryNameById }}</rr-badge>
    } @if(stream?.ideaTypeId) {
    <rr-badge>{{ stream?.ideaTypeId! | getIdeaTypeNameById }}</rr-badge>
    } @if(stream?.businessTypeId) {
    <rr-badge>{{ stream?.businessTypeId! | getBusinessTypeNameById }}</rr-badge>
    } -->
</div>
